import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { TagColor as TagColorType, TagColorListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const TAG_COLOR_FIELDS = `color createdDate entity id isOrgTag lastUsedDate name orgId updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query TagColors($search: String, $pagination: PaginationInput, $sort: SortInput) {
    tagColors(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        color
        createdDate
        entity
        id
        isOrgTag
        lastUsedDate
        name
        orgId
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query TagColor($id: ID!) {
    tagColor(id: $id) {
      color
      createdDate
      entity
      id
      isOrgTag
      lastUsedDate
      name
      orgId
      updatedDate
      version
      workspaceId
    }
  }
`)

export class TagColorStore extends EntityStore<TagColorType, TagColorListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.tagColors,
      extractOne: (data: any) => data.tagColor,
      extractMutated: (data: any) => data.updateTagColor,
    })
  }
}
